import { render, staticRenderFns } from "./productNav.vue?vue&type=template&id=46973f79&scoped=true"
import script from "./productNav.vue?vue&type=script&lang=js"
export * from "./productNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46973f79",
  null
  
)

export default component.exports